import React, {Component} from 'react';
import AppHeader from '../../Misc/AppHeader';
import NotificationSystem from 'react-notification-system';
import {postWithHeaders} from "../../../server/actionsParent";
import Cookies from 'universal-cookie';
import {_addNotification, _addNotificationError, createCookie} from '../../../server/util';
import {BeatLoader} from 'react-spinners'
import PropTypes from "prop-types";
import Phone from 'react-phone-number-input';

class ParentDeviceRegister extends Component {
    componentWillMount = () => {
    }
    onRequestOTP = (event) => {
        let isResendOTP = false;
        if (event.target.name === 'btnResendOTP') {
            isResendOTP = true;

        }
        this.setState({loading: true})
        let reqObj = {};
        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };
        if (this.state.isEmailChecked || this.state.isMobileChecked) {
            if(this.state.isMobileChecked && this.state.validateDevResp.mobileNumber == null){
                if(this.state.mobileNo.trim() == ''){
                    _addNotificationError('Please enter mobile number.', this); 
                    this.setState({ loading: false });
                    return false;
                }
            }
            reqObj.username = sessionStorage.getItem('loggedInUserInfo');
            reqObj.otpOn = (this.state.isEmailChecked && this.state.isMobileChecked) ? 'both' : this.state.isEmailChecked ? 'email' : this.state.isMobileChecked ? 'mobile' : '';
            reqObj.parentMobile = (this.state.isMobileChecked) ? (this.state.validateDevResp.mobileNumber == null) ? this.state.mobileNo : '':'';
            postWithHeaders('/generateOTP?access_token=', JSON.stringify(reqObj), headers).then((response) => {
                if (!response.ok) {
                    _addNotificationError('Request failed. Please try again.', this);
                    throw Error(response.message);
                }
                return response.json();
            }).then((data) => {
                if (data.status) {
                    this.setState({
                        isOTPInpitShow: true,
                        loading: false
                    });
                    if (isResendOTP) {
                        _addNotification('Re-sent code Successfully.', this);
                    }
                    else {
                        _addNotification('Verification code sent Successfully.', this);
                    }
                }


            })
                .catch(
                    (error) => {
                        _addNotificationError('Could not send the code.Please try again later.', this);
                        this.setState({loading: false})
                        console.log('Parent dashobard error', error);
                    }
                )

        }
        else {
            _addNotificationError('Select atleast one option to get the code.', this);
            this.setState({loading: false})
        }
    }
    onValidateOTP = (e) => {
        e.preventDefault();
        this.setState({loading: true})

        if (this.state.otp.length > 0) {

            let reqObj = {
                "username": sessionStorage.getItem('loggedInUserInfo'),
                "otp": this.state.otp,
                "deviceId": this.state.deviceId,
                "fToken": sessionStorage.getItem('ftoken'),
                "deviceIP": "47.12.11.00"
            };
            let headers = {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            };
            postWithHeaders('/validateOTP?access_token=',JSON.stringify(reqObj),headers).then((response) => {
                if (!response.ok) {
                    _addNotificationError('Code Validation failed. Please try again.', this);
                    throw Error(response.message);
                }
                return response.json();
            }).then((data) => {
                //  if (data.status == 'Device registered successfully' || data.status == 'Device already registered.') {
                /*  const cookies = new Cookies();
                 let expDate=new Date().setFullYear(new Date().getFullYear()+10)
                 cookies.set('parent', JSON.stringify({'token':sessionStorage.getItem('ftoken'),'email':sessionStorage.getItem('loggedInUserInfo')}),
                  { path: '/' }); */

                createCookie('parent', JSON.stringify({
                    'token': sessionStorage.getItem('ftoken'),
                    'email': sessionStorage.getItem('loggedInUserInfo')
                }), 300);
                this.setState({loading: false})
                this.context.router.history.push('/parent')
                return false;
                //}
            })
                .catch(
                    (error) => {
                        this.setState({loading: false})
                        console.log('Parent dashobard error', error);
                    }
                );

        }
    }
    onCheckboxChange = (event) => {
        if (event.target.name === 'email') {
            this.setState({isEmailChecked: event.target.checked});
        }
        if (event.target.name === 'mobile') {
            this.setState({isMobileChecked: event.target.checked});
        }
    }
    onOTPChange = (event) => {
        this.setState({otp: event.target.value});
    }
    handleMobileNoChange = () => (evt) => {
        let input = document.getElementById('mobileNoAdd');
        input.oninput = function (event) {
            event.target.setCustomValidity('')
        }
        input.oninvalid = function (event) {
            event.target.setCustomValidity('Please enter a valid mobile number');
        }
        if (evt) {
            this.setState({mobileNo: evt});
        }

    };
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            userName: "",
            cookies: new Cookies(),
            isCookie: false,
            validateDevResp: {},
            deviceId: '',
            otp: '',
            mobileNo:'',
            isOTPInpitShow: false,
            isEmailChecked: false,
            isMobileChecked: false
        }
        //sessionStorage.setItem('access_token', '83d32e48-e41b-4058-9711-921ea1af20c1');
    }

    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
        let validateDevString = sessionStorage.getItem('validateresp') === undefined ? '' : sessionStorage.getItem('validateresp');
        let validateObj = (validateDevString === '' ? {} : JSON.parse(validateDevString));
//let validateObj=this.props.validateresp;
        //console.log(validateObj);
        if (Object.keys(validateObj).length !== 0) {
            this.setState({validateDevResp: validateObj});
            this.setState({deviceId: validateObj.deviceId});
        }
        else {
            this.context.router.history.push('/404')
            return true;
        }
    }

    render() {


        return (
            <div>
                <NotificationSystem ref="notificationSystem"/>
                <AppHeader/>
                <div className='sweet-loading' style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000   '}}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <div className="container">
                    <div className="sectionTitle">
                        <h2>
                            <span>Register Device</span>
                        </h2>
                    </div>
                </div>


                <section className="mainContent full-width clearfix">
                    <div className="container">
                        <div className='row'>
                            <div className="col-md-4 col-md-offset-4 col-sm-8 col-sm-offset-2 col-xs-12">
                                <div className="panel panel-default formPanel">
                                    <div className="panel-heading bg-color-1 border-color-1">
                                        <h3 className="panel-title">Send Verification Code</h3>
                                    </div>
                                    <div className="panel-body panel-sendOTP">
                                        <form role="form">
                                            {(this.state.isOTPInpitShow === false ?
                                                <div className="form-group">
                                                    <div className="checkbox col-xs-12">
                                                        <label>
                                                            <input type="checkbox" checked={this.state.isEmailChecked}
                                                                   onChange={this.onCheckboxChange} name="email"
                                                                   value="email" style={{top:'-1px'}}/> &nbsp;Email
                                                        </label>
                                                    </div>
                                                </div>
                                                : null)}

                                            {/* {(this.state.isOTPInpitShow === false ? (this.state.validateDevResp.mobileNumber == null ? null : */}
                                            {(this.state.isOTPInpitShow === false ?
                                                <div className="form-group formField">
                                                    <div className="checkbox col-xs-12">
                                                        <label>
                                                            <input type="checkbox"
                                                                checked={this.state.isMobileChecked}
                                                                onChange={this.onCheckboxChange} name="mobile"
                                                                value="mibule"/> &nbsp;Mobile
                                                            </label>
                                                    </div>
                                                </div>
                                                // ) : null)}
                                                : null)}
                                            {(this.state.isMobileChecked === true ? (this.state.isOTPInpitShow === false ? (this.state.validateDevResp.mobileNumber == null ? 
                                                <div className="col-md-12 col-sm-12 col-xs-12 form-group">                                              
                                                    <Phone
                                                                className="form-control"
                                                                id="mobileNoAdd"
                                                                type="tel"
                                                                value={this.state.mobileNo}
                                                                country={'US'}
                                                                countries={['US', 'CA']}
                                                                placeholder={'Mobile Number'}
                                                                onChange={this.handleMobileNoChange()}
                                                                smartCaret={false}
                                                                displayInitialValueAsLocalNumber={true}
                                                                pattern="[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$" //only for us
                                                                maxlength="15"
                                                                //title="Please enter valid mobile number"

                                                            />
                                                </div>
                                            :null) : null):null)}

                                            {(this.state.isOTPInpitShow === false ?
                                                <div className="form-group formField">
                                                    <input type="button" id="btnRequestOtp" name="btnReqOTP"
                                                           style={{margin: '0px'}}
                                                           className="btn btn-primary btn-block bg-color-3 border-color-3"
                                                           value="Request Code" onClick={this.onRequestOTP}
                                                    />
                                                </div> : null)}

                                            {(this.state.isOTPInpitShow ?
                                                <form onSubmit={this.onValidateOTP}>
                                                    <div className="form-group formField">
                                                        <input type='text' name='txtOTP' className="form-control"
                                                               placeholder="Enter verification code"
                                                               value={this.state.otp}
                                                               onChange={this.onOTPChange} required/>
                                                    </div>
                                                    <div className="form-group formField clearfix">
                                                        <button type="button" name='btnResendOTP'
                                                                onClick={this.onRequestOTP}
                                                                className="btn-social btn-twitter-link"
                                                                style={{padding: '0'}}><span
                                                            style={{marginLeft: '4px'}}>Resend Code</span>
                                                        </button>
                                                    </div>
                                                    <div className="form-group formField">
                                                        <button type="submit" id="btnRequestOtp" name="signin_btn"
                                                                className="btn btn-success pull-right"
                                                                style={{margin: '0px'}}
                                                        >Validate
                                                        </button>
                                                    </div>
                                                </form>
                                                : null)}
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </div>

        );
    }

}

ParentDeviceRegister.contextTypes = {
    router: PropTypes.object.isRequired
}

export default ParentDeviceRegister;


// WEBPACK FOOTER //
// ./src/components/Parent/Home/parentDeviceRegister.jsx